exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.logo[data-v-9aa2f17a] {\n    text-align: center;\n    margin: 2rem;\n}\n.formCard[data-v-9aa2f17a] {\n    min-height: 12rem;\n}\n@media screen and (max-width: 896px) {\n.formCard[data-v-9aa2f17a] {\n        min-height: 12rem;\n}\n}\n@media screen and (max-width: 575px) {\n.formCard[data-v-9aa2f17a] {\n        min-height: 7rem;\n}\n}\n.signInForm[data-v-9aa2f17a] {\n    height: 100vh;\n}\n", ""]);

// exports
